import React, { useRef } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';

import { ReactComponent as CloseCircle } from '../../assets/icons/close-circle.svg';

/**
 * Modal Box function component
 */
function ModalBox({
  title,
  content,
  closeModal,
  open,
  header,
  rightCorner,
  notification,
  version,
  position,
}: {
  title: String | null;
  content: JSX.Element | null;
  closeModal: () => void;
  open: boolean;
  header: boolean;
  rightCorner: string;
  notification?: boolean;
  version?: string;
  position?:
    | 'center'
    | 'top'
    | 'bottom'
    | 'left'
    | 'right'
    | 'top-left'
    | 'top-right'
    | 'bottom-left'
    | 'bottom-right'
    | 'top-right'
    | 'bottom-right'
    | 'top-left'
    | 'bottom-left';
}) {
  const { i18n } = useTranslation();
  const reference = useRef<HTMLDivElement>(null);
  /**
   * Click the outside page function
   */
  const handleClickOutside = (event: React.MouseEvent) => {
    const brand = process.env.REACT_APP_BRANDING === 'voltie';
    if (reference.current === event.target) {
      if (!brand) {
        closeModal();
      }
    }
  };
  return open
    ? ReactDOM.createPortal(
        <div
          className={`modal-box-wrap open ${rightCorner} ${position}`}
          onClick={handleClickOutside}
          role="presentation"
          ref={reference}
          dir={i18n.dir()}>
          <div className="modal-box-container">
            {header && (
              <div className={`modal-box-header-${version}`}>
                <div className="modal-box-title">
                  <span>{title}</span>
                </div>
                <div className="modal-box-icon" onClick={closeModal} role="presentation">
                  <CloseCircle />
                </div>
              </div>
            )}
            <div className="modal-box-body">
              {!header && !notification && (
                <div className="modal-box-icon" onClick={closeModal} role="presentation">
                  <CloseCircle />
                </div>
              )}
              {content}
            </div>
          </div>
        </div>,
        document.body,
      )
    : null;
}

ModalBox.defaultProps = {
  notification: false,
  version: 'v1',
  position: 'center',
};
export default ModalBox;
